import { render, staticRenderFns } from "./lfmenu.vue?vue&type=template&id=7f0ffabc&scoped=true&"
import script from "./lfmenu.vue?vue&type=script&lang=js&"
export * from "./lfmenu.vue?vue&type=script&lang=js&"
import style0 from "./lfmenu.vue?vue&type=style&index=0&id=7f0ffabc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0ffabc",
  null
  
)

component.options.__file = "lfmenu.vue"
export default component.exports